import { httpClient } from "@/lib/http-client"

export class Observation {
  constructor(id: string, name: string, description: string | null, typeCodeId: string, siteId: string, areaId: string | null, featureId: string | null, latitude: number | null, longitude: number | null) {
    this.id = id
    this.name = name
    this.description = description
    this.typeCodeId = typeCodeId
    this.siteId = siteId
    this.areaId = areaId
    this.featureId = featureId
    this.latitude = latitude
    this.longitude = longitude
  }

  id: string
  name: string
  description: string | null
  siteId: string
  areaId: string | null
  featureId: string | null
  typeCodeId: string
  observedAt: string | null = null
  observedById: string | null = null
  latitude: number | null = null
  longitude: number | null = null
  areaName: string | null = null
  featureTypeId: string | null = null
  featureName: string | null = null
  featureTypeName: string | null = null
  featureTypeSubType: string | null = null
  observedByName: string | null = null
  attachmentUrl: string | null = null
}

export class ObservationService {
  private static readonly BASE_PATH = "/api/observations"

  static getById(observationId: string): Promise<Observation> {
    return httpClient.get<Observation>(`${this.BASE_PATH}/${observationId}`)
  }

  static create(observation: Omit<Observation, "id">): Promise<Observation> {
    return httpClient.post<Observation>(`${this.BASE_PATH}`, observation)
  }  

  static update(observationId: string, observation: Observation): Promise<void> {
    return httpClient.put<void>(`${this.BASE_PATH}/${observationId}`, observation)
  }

  static getByFeatureId(featureId: string): Promise<Observation[]> {
    return httpClient.get<Observation[]>(`${this.BASE_PATH}/features/${featureId}`)
  }

  static getByFeatureTypeId(featureTypeId: string): Promise<Observation[]> {
    return httpClient.get<Observation[]>(`${this.BASE_PATH}/featuretypes/${featureTypeId}`)
  }

  static getBySiteId(siteId: string): Promise<Observation[]> {
    return httpClient.get<Observation[]>(`${this.BASE_PATH}/sites/${siteId}`)
  }

  static delete(observationId: string): Promise<void> {
    return httpClient.delete<void>(`${this.BASE_PATH}/${observationId}`)
  }

  static async getByAreaIdCourse(areaId: string): Promise<Observation[]> {
    return httpClient.get<Observation[]>(`${this.BASE_PATH}/areas/${areaId}/course`)
  }

  static async getByAreaIdHabitat(areaId: string): Promise<Observation[]> {
    return httpClient.get<Observation[]>(`${this.BASE_PATH}/areas/${areaId}/habitat`)
  }
}